import Alpine        from 'alpinejs';
import createQuizApp from './alpine/quizApp.js';

// Quiz professions
const quizAppConfig = {
	questions : [
		{
			text    : 'Что для тебя интереснее?',
			answers : [
				{
					text     : 'Чинить сломанный велосипед или компьютер.',
					category : 'technical',
				},
				{
					text     : 'Организовать корпоративное мероприятие или праздник для друзей и знакомых.',
					category : 'social',
				},
			],
		},
		{
			text    : 'Куда бы ты охотнее пошла (пошёл)?',
			answers : [
				{
					text     : 'В поход с палатками, чтобы изучить природу.',
					category : 'creative',
				},
				{
					text     : 'На экскурсию, чтобы увидеть, как работают современные предприятия.',
					category : 'social',
				},
			],
		},
		{
			text    : 'Какая задача увлекательнее?',
			answers : [
				{
					text     : 'Придумать и нарисовать дизайн чего-то нового.',
					category : 'creative',
				},
				{
					text     : 'Рассчитать, из какого материала сделать что-нибудь нужное или полезное.',
					category : 'analytical',
				},
			],
		},
		{
			text    : 'Что важнее, на твой взгляд?',
			answers : [
				{
					text     : 'Защищать природу от мусора и загрязнений.',
					category : 'analytical',
				},
				{
					text     : 'Гарантировать, что все работают безопасно и по правилам.',
					category : 'analytical',
				},
			],
		},
		{
			text    : 'Чем тебе интереснее заняться?',
			answers : [
				{
					text     : 'Изучать, почему извергаются вулканы, как образуются полезные ископаемые.',
					category : 'analytical',
				},
				{
					text     : 'Анализировать данные о продажах игр или популярности музыки.',
					category : 'analytical',
				},
			],
		},
		{
			text    : 'Что тебе ближе?',
			answers : [
				{
					text     : 'Работать руками: строить, собирать, чинить.',
					category : 'technical',
				},
				{
					text     : 'Работать с людьми: учить, консультировать, поддерживать.',
					category : 'social',
				},
			],
		},
		{
			text    : 'Как бы ты действовал (-а) в сложной ситуации (например, прорвало трубу)?',
			answers : [
				{
					text     : 'Быстро взять инструменты и попытаться починить самому.',
					category : 'technical',
				},
				{
					text     : 'Вызвать специалистов и организовать их работу.',
					category : 'social',
				},
			],
		},
		{
			text    : 'Что тебе интереснее изучать?',
			answers : [
				{
					text     : 'Свойства веществ: почему что-то горит, растворяется, меняет цвет.',
					category : 'engineering',
				},
				{
					text     : 'Законы и правила: как они работают, как их применять.',
					category : 'analytical',
				},
			],
		},
		{
			text    : 'Какая роль кажется привлекательнее?',
			answers : [
				{
					text     : 'Тот, кто находит новые решения и придумывает что-то новое.',
					category : 'creative',
				},
				{
					text     : 'Тот, кто точно и аккуратно выполняет важную работу по инструкции.',
					category : 'analytical',
				},
			],
		},
		{
			text    : 'Как тебе кажется, что полезнее?',
			answers : [
				{
					text     : 'Помогать людям напрямую. Например, лечить, учить, тренировать.',
					category : 'social',
				},
				{
					text     : 'Обеспечивать работу других. Например, закупать, перевозить, считать&nbsp;деньги.',
					category : 'creative',
				},
			],
		},
		{
			text    : 'Как тебе кажется, что важнее для успеха проекта?',
			answers : [
				{
					text     : 'Крутая идея и её яркая презентация.',
					category : 'creative',
				},
				{
					text     : 'Точный расчёт бюджета и сроков.',
					category : 'analytical',
				},
			],
		},
		{
			text    : 'Куда бы ты хотел (-а) направить свои таланты и способности?',
			answers : [
				{
					text     : 'На то, чтобы понять, как устроен и работает сложный механизм.',
					category : 'engineering',
				},
				{
					text     : 'На то, чтобы понять, как думают и чувствуют себя люди в коллективе.',
					category : 'social',
				},
			],
		},
		{
			text    : 'Как ты думаешь, какая работа требует большей смелости?',
			answers : [
				{
					text     : 'Работа, от которой зависит безопасность и здоровье других людей, но&nbsp;есть время, чтобы составить план' +
                        ' действий.',
					category : 'technical',
				},
				{
					text     : 'Работа, где нужно действовать мгновенно, без раздумий, чтобы спасти людей.',
					category : 'social',
				},
			],
		},
		{
			text    : 'Что точнее описывает тебя?',
			answers : [
				{
					text     : 'Я внимателен к деталям и люблю, когда всё точно и правильно.',
					category : 'engineering',
				},
				{
					text     : 'Я вижу общую картину и могу придумать стратегию.',
					category : 'creative',
				},
			],
		},
		{
			text    : 'Что интереснее, по-твоему?',
			answers : [
				{
					text     : 'Управлять большой техникой (краном, поездом, экскаватором).',
					category : 'technical',
				},
				{
					text     : 'Планировать маршруты перевозок или распределять ресурсы.',
					category : 'analytical',
				},
			],
		},
		{
			text    : 'Чем бы ты хотел (-а) заняться в&nbsp;лаборатории?',
			answers : [
				{
					text     : 'Ставить эксперименты и наблюдать за реакциями.',
					category : 'technical',
				},
				{
					text     : 'Анализировать полученные данные на компьютере.',
					category : 'engineering',
				},
			],
		},
		{
			text    : 'Какая задача кажется легче?',
			answers : [
				{
					text     : 'Убедить людей сделать что-то важное.',
					category : 'creative',
				},
				{
					text     : 'Найти ошибку в сложном чертеже или коде программы.',
					category : 'engineering',
				},
			],
		},
		{
			text    : 'Что ценнее, на твой взгляд?',
			answers : [
				{
					text     : 'Умение работать в команде и поддерживать других.',
					category : 'social',
				},
				{
					text     : 'Умение самостоятельно решать сложные технические задачи.',
					category : 'engineering',
				},
			],
		},
		{
			text    : 'Где твоя стихия?',
			answers : [
				{
					text     : 'В поле, в горах, на открытом воздухе, возможно, в экспедиции.',
					category : 'analytical',
				},
				{
					text     : 'В офисе с компьютером, в лаборатории или на производственном объекте.',
					category : 'social',
				},
			],
		},
		{
			text    : 'Какой вклад значимее?',
			answers : [
				{
					text     : 'Непосредственно создать что-то полезное своими руками или умом.',
					category : 'technical',
				},
				{
					text     : 'Организовать процесс, чтобы много людей могли работать эффективно.',
					category : 'creative',
				},
			],
		},
	], // Will use default questions from quizApp
};

// Quiz parents
const quizAppParentConfig = {
	questions : [
		{
			text    : 'В ситуации поломки (велосипед, гаджет) ваш ребёнок скорее:',
			answers : [
				{
					text     : 'Попытается разобраться сам, покрутит, посмотрит, попробует починить.',
					category : 'technical',
				},
				{
					text     : 'Обратится за помощью к тому, кто может это починить (к вам, к специалисту), или начнёт искать, кого можно организовать для решения проблемы.',
					category : 'social',
				},
			],
		},
		{
			text    : 'От какой семейной поездки он/она получит больше удовольствия?',
			answers : [
				{
					text     : 'От похода с палатками, где можно изучать природу.',
					category : 'creative',
				},
				{
					text     : 'От экскурсии на современное предприятие, фабрику, в бизнес-центр, где можно увидеть, как устроены процессы изнутри.',
					category : 'social',
				},
			],
		},
		{
			text    : 'Какая задача его/её больше увлечёт?',
			answers : [
				{
					text     : 'Придумать и нарисовать дизайн своей будущей комнаты или персонажа для комикса.',
					category : 'creative',
				},
				{
					text     : 'Рассчитать, хватит ли карманных денег на крупную покупку или из чего лучше собрать модельку, чтобы она была прочной.',
					category : 'analytical',
				},
			],
		},
		{
			text    : 'Что его/её волнует больше?',
			answers : [
				{
					text     : 'Проблема загрязнения окружающей среды (мусор на улице, пластик в&nbsp;океане).',
					category : 'analytical',
				},
				{
					text     : 'Вопросы справедливости и соблюдения правил, честность и безопасность.',
					category : 'analytical',
				},
			],
		},
		{
			text    : 'Чем ему/ей интереснее заняться в свободное время?',
			answers : [
				{
					text     : 'Смотреть научные фильмы о вулканах, динозаврах, космосе, проводить простые опыты.',
					category : 'analytical',
				},
				{
					text     : 'Анализировать, почему одна игра или блогер популярнее другого, следить за статистикой и трендами.',
					category : 'analytical',
				},
			],
		},
		{
			text    : 'Что ему/ей даётся легче?',
			answers : [
				{
					text     : 'Работа руками: собрать конструктор, помочь с мелким ремонтом, что-то смастерить.',
					category : 'technical',
				},
				{
					text     : 'Общение с людьми: объяснить что-то сверстникам, утешить, поддержать, научить.',
					category : 'social',
				},
			],
		},
		{
			text    : 'В бытовой стрессовой ситуации (прорвало трубу, отключили свет) ваш ребёнок:',
			answers : [
				{
					text     : 'Проявит инициативу: попробует что-то сделать сам, подаст инструменты, полезет с фонариком.',
					category : 'technical',
				},
				{
					text     : 'Начнёт звонить / звать на помощь, будет координировать общение между взрослыми.\n',
					category : 'social',
				},
			],
		},
		{
			text    : 'Что его/её больше привлекает в науке?',
			answers : [
				{
					text     : 'Свойства материалов и веществ: почему лёд тает, а сахар растворяется.',
					category : 'engineering',
				},
				{
					text     : 'Причины и следствия событий, правила, по которым живёт общество.',
					category : 'analytical',
				},
			],
		},
		{
			text    : 'В игре или школьном проекте какая роль ему/ей ближе?',
			answers : [
				{
					text     : 'Генератор идей, изобретатель, тот, кто придумывает новое.',
					category : 'creative',
				},
				{
					text     : 'Исполнитель, который тщательно прорабатывает детали и следит за соблюдением правил.',
					category : 'analytical',
				},
			],
		},
		{
			text    : 'Какой вклад он/она чаще вносит в семейные дела?',
			answers : [
				{
					text     : 'Помогает напрямую: объяснить младшей сестре уроки, помочь бабушке с&nbsp;телефоном.',
					category : 'social',
				},
				{
					text     : 'Помогает с организацией: составить список покупок, помочь спланировать маршрут поездки.\n',
					category : 'creative',
				},
			],
		},
		{
			text    : 'Что ваш ребёнок считает более важным для успеха общего дела (например, школьного проекта)?',
			answers : [
				{
					text     : 'Креативная, яркая идея и умение её эффектно представить.',
					category : 'creative',
				},
				{
					text     : 'Реалистичный план, точный расчёт затрат и сроков.',
					category : 'analytical',
				},
			],
		},
		{
			text    : 'Ваш ребёнок больше интересуется:',
			answers : [
				{
					text     : 'Тем, как устроены и работают сложные механизмы, приборы или компьютерные программы.',
					category : 'engineering',
				},
				{
					text     : 'Тем, как устроены отношения в коллективе, почему люди поступают так, а не иначе, что ими движет.',
					category : 'social',
				},
			],
		},
		{
			text    : 'Какую ситуацию он/она, скорее всего, сочтёт более ответственной и требующей смелости?',
			answers : [
				{
					text     : 'Работа, где от продуманного плана и расчётов зависит безопасность многих людей (например, проектирование моста или разработка правил эвакуации).',
					category : 'technical',
				},
				{
					text     : 'Работа, где нужно мгновенно реагировать на чрезвычайную ситуацию, чтобы спасти человека «здесь и сейчас»' +
                        ' (например, работа спасателя МЧС).',
					category : 'social',
				},
			],
		},
		{
			text    : 'Что точнее описывает подход вашего ребёнка к решению задач?',
			answers : [
				{
					text     : 'Он внимателен к деталям, любит, когда всё разложено по полочкам и соответствует инструкции.',
					category : 'engineering',
				},
				{
					text     : 'Он сначала пытается понять общую картину и придумать общую стратегию, а детали прорабатывает позже.',
					category : 'creative',
				},
			],
		},
		{
			text    : 'Какая деятельность на экскурсии или в игре покажется ему/ей увлекательнее?',
			answers : [
				{
					text     : 'Управление симулятором большой техники (крана, поезда, экскаватора).',
					category : 'technical',
				},
				{
					text     : 'Участие в планировании: например, как оптимально распределить технику по объектам или построить маршруты перевозок.\n',
					category : 'analytical',
				},
			],
		},
		{
			text    : 'Если представить его/её работающим (-ей) в лаборатории или научном центре, что будет ему/ей ближе?',
			answers : [
				{
					text     : 'Непосредственное проведение экспериментов, наблюдение за&nbsp;реакциями и процессами.',
					category : 'technical',
				},
				{
					text     : 'Обработка и анализ полученных данных, построение графиков и&nbsp;формулировка выводов на компьютере.\n',
					category : 'engineering',
				},
			],
		},
		{
			text    : 'Какую задачу, по вашим наблюдениям, он/она решает легче?',
			answers : [
				{
					text     : 'Убедить сверстников или даже взрослых в своей точке зрения, повести их за собой.',
					category : 'creative',
				},
				{
					text     : 'Найти ошибку в сложной схеме, компьютерном коде или чертеже.',
					category : 'engineering',
				},
			],
		},
		{
			text    : 'Что, по мнению вашего ребёнка, является более ценным умением?',
			answers : [
				{
					text     : 'Умение работать в команде, поддерживать других и находить общий&nbsp;язык.',
					category : 'social',
				},
				{
					text     : 'Умение самостоятельно разобраться в сложном устройстве или решить трудную техническую задачу.',
					category : 'engineering',
				},
			],
		},
		{
			text    : 'Где, как вам кажется, он/она чувствует себя более уверенно и комфортно?',
			answers : [
				{
					text     : 'На открытом воздухе: в походе, на сплаве, в геологической или экологической экспедиции.',
					category : 'analytical',
				},
				{
					text     : 'В помещении, где есть чёткая структура: в офисе с компьютером, в&nbsp;лаборатории, на современном производственном объекте.',
					category : 'social',
				},
			],
		},
		{
			text    : 'Какой вклад в общее дело ваш ребёнок считает более значимым?',
			answers : [
				{
					text     : 'Непосредственно создать что-то нужное — собрать устройство, написать программу, нарисовать макет.',
					category : 'technical',
				},
				{
					text     : 'Организовать процесс так, чтобы все участники работали слаженно и&nbsp;эффективно.',
					category : 'creative',
				},
			],
		},
	],
};

// Init
function init() {
	window.Alpine = Alpine;
	Alpine.prefix('data-x-');

	// Register both quiz instances with their configs
	Alpine.data('quizApp', () => createQuizApp(quizAppConfig));
	Alpine.data('quizAppParent', () => createQuizApp(quizAppParentConfig));

	Alpine.start();
}

(function () {
	init();
}());
